import type { SolarAnchor } from "@/lib/solar/calculateSolarPosition";
import type { DebugSettings } from "@/services/debugSettingsService";
import type { Season } from "@/stores/solarSimulationStore";
import type { SubmissionType } from "@/types/project";

import type { BasemapLightingOptions, SolarDrivenLightingOptions } from "./types";

export function buildBasemapLightingOptionsFromDebugSettings(
  settings: DebugSettings,
  hour: number,
  season: Season,
  anchor?: SolarAnchor,
): BasemapLightingOptions {
  return {
    imageBasedLightingFactor: {
      diffuse:
        settings.modeShaderBasemap === "lit_sdr"
          ? Math.min(Math.max(settings.facteurIblLitSdr, 0), 1)
          : 1.0,
      specular: settings.modeShaderBasemap === "lit_sdr" ? 0.0 : 1.0,
    },
    lightColorIntensity:
      settings.modeShaderBasemap === "lit_sdr"
        ? settings.intensiteLumiereBasemapLitSdr
        : undefined,
    plancherLumineuxLit:
      settings.modeShaderBasemap === "lit_sdr"
        ? settings.plancherLumineuxLit
        : 0,
    plancherLumineuxDynamique: {
      actif: settings.plancherLumineuxDynamiqueActif,
      minimum: settings.plancherLumineuxBasemapNuit,
      maximum: settings.plancherLumineuxDynamiqueMax,
      hour,
      season,
    },
    attenuationNocturne: {
      actif: settings.attenuationNocturneBasemapActive,
      iblMinimum: settings.facteurIblBasemapNuit,
      lightColorMinimum: settings.intensiteBasemapNuit,
      hour,
      season,
    },
    solaire: {
      hour,
      season,
      anchor,
    },
  };
}

export function buildSolarLightingOptionsFromDebugSettings(
  settings: DebugSettings,
  hour: number,
  season: Season,
  anchor: SolarAnchor | undefined,
  submissionType?: SubmissionType | null,
): SolarDrivenLightingOptions {
  const multiplicateurIntensiteLumiere =
    submissionType === "BUILDING"
      ? settings.intensiteLumiereArchitecte
      : submissionType === "LANDSCAPE"
        ? settings.intensiteLumierePaysage
        : 1;

  return {
    hour,
    season,
    anchor,
    multiplicateurIntensiteLumiere,
  };
}
